import React from 'react'
import {connect} from 'react-redux'
import {formValueSelector} from 'redux-form'
import {getCurrent} from "../steps/StepsReducers";
import {select, finish} from "../steps/StepsActions";
import {STEP_SETUP_ENVIRONMENT} from "../steps/StepsContants";
import {receive} from '../result/ResultActions';
import './Bridge.css';
import html from 'react-escape-html'
import BridgeForm from "./BridgeForm";
import {
  bridgeLoaded,
  bridgeValidate,
  bridgeValidateResult,
  bridgeAddValidationListener,
  bridgeRemoveValidationListener
} from './BridgeActions';
import {getWidgetRef, isBridgeLoaded} from "./BridgeReducers";
import {FormUtils} from "../utils/FormUtils";
import {bridgeResultFactory} from "./BridgeMethodsFactory";

const BridgeContainer = ({state, config, currentStep, select, finish, receive, bridgeLoaded, bridgeValidate, bridgeValidateResult, isLoaded, widgetRef, bridgeAddValidationListener, bridgeRemoveValidationListener}) => {

  const previous = () => {
    select(STEP_SETUP_ENVIRONMENT);
  };

  let selectedCofType = formValueSelector('bridge')(state, 'creditCard.cofContract.type');
  let bridgeResult = bridgeResultFactory(selectedCofType, config, finish, receive);

  const onSubmit = values => {
    document.getElementById('inline-widget-container').innerHTML = '';
    removeValidationListener();

    window.PayEngineWidget.initAsInlineComponentPi(
      'inline-widget-container',
      values.merchantId,
      getOptionalParameters(),
      bridgeResult.execFunction
    );
    window.scrollTo(0, 1000);
  };

  const getConfigUrl = () => {
    let scriptTag = `<script src="${state.config.environment.widgetUrl}"></script>`;
    let bridgetTag = `<script src="${state.config.environment.bridgeUrl}"></script>`;
    let setPublisableKeyTag = `<script type="text/javascript">
  window.PayEngine.setPublishableKey('${config.environment.merchantId}');
</script>`;
    return html`${scriptTag}
${bridgetTag}
${setPublisableKeyTag}
`;
  };

  const validationListenerCallback = (data) => {
    console.log('Validation listener callback', data);
    bridgeValidate(data);
  };

  const validate = () => {
    function onValidationCallback(error, result) {
      console.log('Validate', error, result);
      bridgeValidateResult(error ? error : result);
    }

    window.PayEngineWidget.validate(widgetRef, onValidationCallback);
  };

  const addValidationListener = () => {
    console.log('Widget REF: ', widgetRef);
    window.PayEngineWidget.addValidationListener(widgetRef, validationListenerCallback);
    bridgeAddValidationListener();
  };

  const removeValidationListener = () => {
    window.PayEngineWidget.removeValidationListener(widgetRef, validationListenerCallback);
    bridgeRemoveValidationListener();
  };

  const pay = () => {
    const onPayCallback = (error, result) => {
      console.log("On pay callback", error, result);
    };
    window.PayEngineWidget.pay(widgetRef, onPayCallback);
  };

  const initCallback = (error, iframeName) => {
    console.log("Init callback", error, iframeName);
    widgetRef = iframeName;
    bridgeLoaded(widgetRef);
  };

  const cofAgreementStateCallback = (error, result) => {
    console.log("cofAgreementStateCallback", error, result);
  };

  const getVlidationResults = () => {
    if (state.bridge.validationListenerAdded) {
      return JSON.stringify(state.bridge.validationResult, null, 2);
    }
    return 'You should call addValidationListener() function';
  };

  const getValidateResult = () => {
    return JSON.stringify(state.bridge.validateResult, null, 2);
  };

  const getOptionalParameters = () => {
    const selector = formValueSelector('bridge');
    const optionalParameters = selector(
      state, 'language', 'layout', 'customStyleId', 'hidePayButton', 'hideTitleIcons', 'skipFinalResultView'
    );
    if (selector(state, 'products')) {
      optionalParameters.products = selector(state, 'products').split(',');
    }

    optionalParameters.paymentDetails = FormUtils.getValuesByUsage(selector(state, 'paymentDetailsUsage'), selector(state, 'paymentDetails'));

    optionalParameters.initCallback = initCallback;
    if (selectedCofType) {
      optionalParameters.cofAgreementStateCallback = cofAgreementStateCallback;
    }

    if (selector(state, 'optionalFields')) {
      let creditCard = null;
      let paypal = null;
      selectedCofType = selector(state, 'creditCard.cofContract.type');

      if (selector(state, 'useCreditCard')) {
        creditCard = {
          cardHolder: selector(state, 'creditCard.cardHolder'),
          cvcNeeded: selector(state, 'creditCard.cvcNeeded'),
          cofContract: {
            type: selectedCofType,
            recurringExpiry: selector(state, 'creditCard.cofContract.recurringExpiry'),
            recurringFrequency: selector(state, 'creditCard.cofContract.recurringFrequency')
          }
        };
        let confContractType = selector(state, 'creditCard.cofContract.type');
        if(confContractType === null || confContractType === '') {
          creditCard = { ...creditCard, cofContract: null};
        }
      }

      if (selector(state, 'refTransaction')) {
        paypal = {
          returnUrl: selector(state, 'paypal.returnUrl'),
          cancelUrl: selector(state, 'paypal.cancelUrl'),
          notifyUrl: selector(state, 'paypal.notifyUrl')
        }
      }

      optionalParameters.optionalFields = {
        creditCard: creditCard,
        sepa: {
          bic: selector(state, 'sepa.bic'),
          bankName: selector(state, 'sepa.bankName'),
          requestMandate: selector(state, 'sepa.requestMandate'),
          directDebitType: selector(state, 'sepa.directDebitType'),
        },
        paypal: paypal
      }
    } else {
      optionalParameters.optionalFields = null;
    }
    return optionalParameters;
  };

  const getOptionalParametersTemplate = () => {
    let params =
      `var optionalParameters = ${JSON.stringify(getOptionalParameters(), null, 2)}
optionalParameters.initCallback = initCallback;
`;
    if (selectedCofType) {
      params = params + `optionalParameters.cofAgreementStateCallback = cofAgreementStateCallback;`;
    }

    return html`${params}`;
  };

  const getResultCallback = () => {
    const callbackCode =
      `var widgetRef, cofAgreementState, cofType = '${selectedCofType}';

function validationListenerCallback(data) {
  console.log('Validation listener callback', data);
}

function addValidationListener() {
  window.PayEngineWidget.addValidationListener(widgetRef, validationListenerCallback);
}

function removeValidationListener() {
  window.PayEngineWidget.removeValidationListener(widgetRef, validationListenerCallback);
}

function pay() {
  function onPayCallback(error, result) {
    console.log("On pay callback", error, result);
  }
  window.PayEngineWidget.pay(widgetRef, onPayCallback);
}

function initCallback(error, iframeName) {
  console.log("Init callback", error, iframeName);
  widgetRef = iframeName;
}
${bridgeResult.visualizeFunction()}
`;
    return html`${callbackCode}`;
  };

  const getInitiWidget = () => {
    const selector = formValueSelector('bridge')
    const merchantId = selector(state, 'merchantId');
    const containerTag = `<div id="inline-widget-container"></div>`;
    let params =
      `window.PayEngineWidget.initAsInlineComponentPi(
  'inline-widget-container',
  '${merchantId}',
  optionalParameters,
  resultCallback
);`;

    return html`${containerTag}
${params}`;
  };


  let callbacksActionsContent = '';
  if (isLoaded) {
    callbacksActionsContent =
      <div>
        <div className="clearfix"></div>
        <hr/>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={addValidationListener}>
                <span className="btn-text">addValidationListener()</span>
              </button>
            </div>
            <div className="col-md-4 col-xs-12 text-center m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={removeValidationListener}>
                <span className="btn-text">removeValidationListener()</span>
              </button>
            </div>
            <div className="col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary col-xs-12" onClick={validate}>
                <span className="btn-text">validate()</span>
              </button>
            </div>
            <div className="col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary col-xs-12" onClick={pay}>
                <span className="btn-text">pay()</span>
              </button>
            </div>
          </div>
        </div>
      </div>
  }

  return (
    <div className="row">
      <div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <BridgeForm onSubmit={values => onSubmit(values)} onPrevious={previous}/>
        </div>
        <div className="col-lg-6 col-md-12 col-xs-12">
          <h3>Configuration</h3>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getConfigUrl()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getResultCallback()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getOptionalParametersTemplate()}></div>
        </pre>
          </blockquote>
          <blockquote>
        <pre>
          <div dangerouslySetInnerHTML={getInitiWidget()}></div>
        </pre>
          </blockquote>
        </div>
        <div>
          <div className="text-center">
            <hr/>
            <h3>Widget</h3>
            {callbacksActionsContent}
          </div>
          <div className="clearfix"></div>
          <hr/>
          <div className="row">
            <div className="col-lg-6 col-md-12 col-xs-12 text-center">
              <h5>The widget will be loaded here (iframe)</h5>
              <div className="widget-container">
                <div id="inline-widget-container"></div>
              </div>
            </div>
            {
              isLoaded ?
                <div className="col-lg-6 col-md-12 col-xs-12">
                  <h5>Validation listener callback</h5>
                  <blockquote>
              <pre>
                {getVlidationResults()}
              </pre>
                  </blockquote>
                  <h5>Validate</h5>
                  <blockquote>
                  <pre>
                    {getValidateResult()}
                  </pre>
                  </blockquote>
                </div> : ''
            }
          </div>
        </div>
      </div>
    </div>
  );
};

BridgeContainer.propTypes = {};

const mapStateToProps = (state) => ({
  state: state,
  currentStep: getCurrent(state),
  isLoaded: isBridgeLoaded(state),
  widgetRef: getWidgetRef(state),
  config: state.app.config
});

export default connect(
  mapStateToProps,
  {select, finish, receive, bridgeLoaded, bridgeValidate, bridgeValidateResult, bridgeAddValidationListener, bridgeRemoveValidationListener}
)(BridgeContainer);



// WEBPACK FOOTER //
// ./src/bridge/BridgeContainer.js